// Components/TreeCategorySelect/index.tsx
import { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { Form } from 'react-bootstrap';
import { ICategories } from '../Cadastro/Categorias/interface/ICategories';

interface Props {
  category: ICategories;
  onToggleCategory: (category: ICategories) => void;
  isSelected: boolean;
  disabled?: boolean;
  isCategorySelected: (categoryId: number) => boolean;
}

function TreeCategorySelect({
  category,
  onToggleCategory,
  isSelected,
  disabled = false,
  isCategorySelected,
}: Props) {
  const [expand, setExpand] = useState(false);

  const hasChildren = category?.relationships?.children?.length > 0;

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onToggleCategory(category);
  };

  const handleExpandClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setExpand(!expand);
  };

  return (
    <>
      <div className="row ItemTree" style={{ paddingTop: '10px' }}>
        <div
          className={`col ${
            hasChildren ? 'subCategoryBackGroup' : 'categoryBackGroup'
          }`}
        >
          <section
            className="divBackgroundColor"
            style={{ 
              paddingLeft: '10px', 
              display: 'flex', 
              alignItems: 'center',
              backgroundColor: isSelected ? '#e7f3ff' : 'transparent',
              transition: 'background-color 0.2s ease'
            }}
          >
            <div className="px-2" style={{ fontSize: '12px', flex: 1, display: 'flex', alignItems: 'center', gap: '8px' }}>
              {/* Checkbox para selecionar categoria */}
              <Form.Check
                type="checkbox"
                id={`category-${category.id}`}
                checked={isSelected}
                onChange={handleCheckboxChange}
                disabled={disabled}
                style={{ 
                  marginBottom: 0,
                  opacity: disabled ? 0.5 : 1
                }}
                onClick={(e) => e.stopPropagation()}
              />
              
              <span 
                style={{ 
                  flex: 1,
                  fontWeight: isSelected ? '600' : '400',
                  color: isSelected ? '#009ef7' : 'inherit'
                }}
              >
                {category?.name.toUpperCase()}
              </span>

              {/* Botão de expandir/recolher */}
              {hasChildren && (
                <button 
                  onClick={handleExpandClick}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    padding: 0, 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    transition: 'transform 0.2s ease'
                  }}
                >
                  {expand ? (
                    <MdKeyboardArrowUp size={20} color="#a1a5b7" />
                  ) : (
                    <MdKeyboardArrowDown size={20} color="#a1a5b7" />
                  )}
                </button>
              )}
            </div>

            {/* Indicador se já está vinculado */}
            <div className="ms-auto">
              {category?.tax_profile_id && (
                <small 
                  className="text-muted" 
                  style={{ 
                    fontSize: '0.75rem', 
                    paddingRight: '10px',
                    backgroundColor: '#fff3cd',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontWeight: '500'
                  }}
                >
                  Vinculado
                </small>
              )}
            </div>
          </section>
        </div>

        {/* Renderizar filhos se expandido */}
        <div 
          style={{ 
            display: expand ? 'block' : 'none',
            transition: 'all 0.3s ease'
          }}
        >
          {category?.relationships?.children?.map((childCategory: any) => (
            <div
              className="d-flex flex-row-reverse bd-highlight"
              key={childCategory?.id}
            >
              <TreeCategorySelect
                category={childCategory}
                onToggleCategory={onToggleCategory}
                isSelected={isCategorySelected(childCategory.id)}
                disabled={disabled}
                isCategorySelected={isCategorySelected}
              />
            </div>
          ))}
        </div>
      </div>

      <div style={{ height: '-5px' }}></div>
    </>
  );
}

export default TreeCategorySelect;